import React, { useEffect } from "react";
import VidFleetVideo from "Modules/.common/components/VidFleetVideo";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import SmartWitnessVideo from "Modules/.common/components/SmartWitnessVideo";
import { LiveMetricsVideo } from "../../../../../../.common/components/LightMetricsVideo";
import { MitacVideo } from "../../../../../../.common/components/MitacVideo";
import { getMarkerDetails } from "Redux/actions";

export const LiveVideo = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { isOpenOverViewUnit } = useSelector((state) => state.incidentsRedux);
  const response = useSelector(state => state.infoBubbleRedux.getMarkerDetailsResponse);

  const unit = isOpenOverViewUnit?.data?.unit;
  const lastReading = isOpenOverViewUnit?.data?.reading;
  const videoDevice = unit?.videoDevices && unit?.videoDevices.length > 0 && unit?.videoDevices[0];
  const isLightMetrics = videoDevice?.manufacturer === "LightMetrics";
  const isMitac = videoDevice?.manufacturer === "Mitac";
  const lastReadingResponse = response?.markerDetail?.unit?.lastReading;

  useEffect(() => {
    if (lastReading) return;
    dispatch(getMarkerDetails({ type: 'Vehicle', id: unit?.id, unitId: unit?.id }));
  }, [lastReading])

  if (isLightMetrics) {
    return (
      <div className="incident_liveVideo_map_liveVideo">
        <LiveMetricsVideo deviceId={unit?.id} lastReading={lastReading || lastReadingResponse} />
      </div>
    )
  }

  if (isMitac) {
    return (
      <div className="incident_liveVideo_map_liveVideo">
        <MitacVideo deviceId={videoDevice?.esn} />
      </div>
    )
  }

  return (
    <div className="incident_liveVideo_map_liveVideo">
      {videoDevice?.manufacturer == "SmartWitness" ? (
        <SmartWitnessVideo
          recorderId={videoDevice?.esn}
          deviceId={videoDevice?.id}
          cameraChannel={
            videoDevice?.cameraChannel || "*"
          }
          messages={messages}
          timeZone={unit?.timeZone?.name}
          vehicleTrail={videoDevice?.vehicleTrail}
        />
      ) : (
        <VidFleetVideo
          messages={messages}
          mode="video"
          type={unit?.liveMode ? unit?.liveMode?.toLowerCase() : "streaming"}
          id={videoDevice?.esn}
          unitId={videoDevice?.id}
          autoplay={false}
          deviceModel={unit?.linkedUnit?.unitVersionProduct === "360" ? "360" : "4k"}
          simProviderName={unit?.simProviderName}
          vehicleEvent={lastReading?.eventName}
          timeZone={unit?.timeZone?.name}
        />
      )}
    </div>
  );
};
